import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AdminService } from '../../services/admin.service';
import { PartnerDTO } from '../../model/partner.entity';
import { Dropdown } from 'primeng/dropdown';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MasterDTO } from '../../model/admin.entity';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-partner',
  templateUrl: './partner.component.html',

})
export class PartnerComponent implements OnInit {

  partnerList: PartnerDTO[] = [];
  model = {} as PartnerDTO;
  partnerTypelist: MasterDTO[] = [];
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;
  selectedPartnerType: [] = [];

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
  private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getPartner().subscribe((x) => {
      this.partnerList = x.value;
    });

    this.service.getPartnerType().subscribe((x) => {
      this.partnerTypelist = x.value;
    });
  }

  addModal() {
    this.model = new PartnerDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.partner');
  }

  save(data: PartnerDTO) {
    // data.AddPartnerPartnerType=data.partnerPartnerType?.filter(a=>!this.selectedPartnerType?.includes(a));
    // data.DeletedPartnerPartnerType=this.selectedPartnerType?.filter((x)=>!data.partnerPartnerType?.includes(x));
    // console.log(data);
    if (data.id > 0) {
      this.service.updatePartner(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.savePartner(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  deletePartner(data: PartnerDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deletePartner(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

  onToggleStatus(item: PartnerDTO) {
  const updatedItem = { ...item }; 
  this.service.updatePartner(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: PartnerDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.partner');
    this.model = data;
    this.selectedPartnerType = data.partnerPartnerType;
    this.showModal = !this.showModal;
  }

          downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('partner').subscribe(blob => {
      this.downloadFile(blob, `partner-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }

}
